import { render, staticRenderFns } from "./AlertSac.vue?vue&type=template&id=57c667ef&scoped=true&"
import script from "./AlertSac.vue?vue&type=script&lang=ts&"
export * from "./AlertSac.vue?vue&type=script&lang=ts&"
import style0 from "./AlertSac.vue?vue&type=style&index=0&id=57c667ef&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c667ef",
  null
  
)

export default component.exports